import styled from 'styled-components'

import { BaseButtonStyled } from '@ui/elements/Button/styles/BaseButtonStyled'

export const DatepickerCalendarPresetsStyled = styled.ul`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  min-height: ${(props) => props.theme.typography.pxToRem(250)};

  padding: 1em 1.5em 1em 0;

  > li + li {
    margin-top: 0.75em;
  }

  ${BaseButtonStyled} {
    width: ${(props) => props.theme.typography.pxToRem(160)};
    box-shadow: none;
  }
`
